import React from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  Animated,
  PanResponder,
  ScrollView,
  TouchableWithoutFeedback,
  TouchableHighlight,
} from "react-native";

import Close from "./Close";
import Bar from "./Bar";

import appStyles from "../../../appStyles";
import { isAndroid } from "../../../../helpers/utils";

let FULL_HEIGHT = Dimensions.get("window").height;
let FULL_WIDTH = Dimensions.get("window").width;
let PANEL_HEIGHT = FULL_HEIGHT * 0.75;
const STATUS = {
  CLOSED: 0,
  SMALL: 1,
  LARGE: 2,
};

export default class SwipeablePanel extends React.Component {
  constructor(props) {
    super(props);
    this.componentDidMount = () => {
      const { isActive, openLarge, onlyLarge, onlySmall } = this.props;
      this.animatedValueY = 0;
      this.listener = (value) => (this.animatedValueY = value.value);
      this.state.pan.y.addListener(this.listener);
      this.setState({ isActive });
      if (isActive)
        this._animateTo(
          onlySmall
            ? STATUS.SMALL
            : openLarge
            ? STATUS.LARGE
            : onlyLarge
            ? STATUS.LARGE
            : STATUS.SMALL,
        );
      Dimensions.addEventListener("change", this._onOrientationChange);
    };
    this.componentWillUnmount = () => {
      this.state.pan.y.removeListener(this.listener);
    };
    this._onOrientationChange = () => {
      const dimesions = Dimensions.get("screen");
      FULL_HEIGHT = dimesions.height;
      FULL_WIDTH = dimesions.width;
      PANEL_HEIGHT = FULL_HEIGHT - 100;
      this.setState({
        orientation:
          dimesions.height >= dimesions.width ? "portrait" : "landscape",
        deviceWidth: FULL_WIDTH,
        deviceHeight: FULL_HEIGHT,
        panelHeight: PANEL_HEIGHT,
      });
      this.props.onClose();
    };
    this._animateTo = (newStatus = 0) => {
      this.setState({
        showComponent: true,
        status: newStatus,
      });
      Animated.spring(this.state.pan, {
        toValue: { x: 0, y: 0 },
        tension: 80,
        friction: 25,
        useNativeDriver: true,
        restDisplacementThreshold: 10,
        restSpeedThreshold: 10,
      }).start(() => {
        if (newStatus === 0) {
          //this.props.onClose();
          this.setState({
            showComponent: false,
          });
        } else
          this.setState({
            canScroll: newStatus === STATUS.LARGE ? true : false,
          });
      });
    };
    this.state = {
      status: STATUS.CLOSED,
      isActive: false,
      showComponent: false,
      canScroll: false,
      opacity: new Animated.Value(0),
      pan: new Animated.ValueXY({ x: 0, y: FULL_HEIGHT }),
      orientation: FULL_HEIGHT >= FULL_WIDTH ? "portrait" : "landscape",
      deviceWidth: FULL_WIDTH,
      deviceHeight: FULL_HEIGHT,
      panelHeight: PANEL_HEIGHT,
    };
    this.pan = new Animated.ValueXY({ x: 0, y: FULL_HEIGHT });
    this.isClosing = false;
    this.animatedValueY = 0;
    this._panResponder = PanResponder.create({
      onStartShouldSetPanResponder: (evt, gestureState) => true,
      onPanResponderGrant: (evt, gestureState) => {
        this.state.pan.setOffset({
          x: 0,
          y: this.animatedValueY,
        });
        this.state.pan.setValue({ x: 0, y: 0 });
      },
      onPanResponderMove: (evt, gestureState) => {
        if (
          (this.state.status === 1 &&
            Math.abs(this.state.pan.y._value) <= this.state.pan.y._offset) ||
          (this.state.status === 2 && this.state.pan.y._value > -1)
        )
          this.state.pan.setValue({
            x: 0,
            y: gestureState.dy,
          });
      },
      onPanResponderRelease: (evt, gestureState) => {
        const { onlyLarge, onlySmall } = this.props;
        this.state.pan.flattenOffset();
        if (gestureState.dy === 0) this._animateTo(this.state.status);
        else if (gestureState.dy < -100 || gestureState.vy < -0.5) {
          if (this.state.status === STATUS.SMALL)
            this._animateTo(onlySmall ? STATUS.SMALL : STATUS.LARGE);
          else this._animateTo(STATUS.LARGE);
        } else if (gestureState.dy > 100 || gestureState.vy > 0.5) {
          if (this.state.status === STATUS.LARGE)
            this._animateTo(onlyLarge ? STATUS.CLOSED : STATUS.SMALL);
          else this._animateTo(0);
        } else this._animateTo(this.state.status);
      },
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const { isActive, openLarge, onlyLarge, onlySmall } = this.props;
    if (prevProps.isActive !== isActive) {
      this.setState({ isActive });
      if (isActive) {
        this._animateTo(
          onlySmall
            ? STATUS.SMALL
            : openLarge
            ? STATUS.LARGE
            : onlyLarge
            ? STATUS.LARGE
            : STATUS.SMALL,
        );
      } else {
        this._animateTo();
      }
    }
    if (prevState.orientation !== this.state.orientation)
      this._animateTo(this.state.status);
  }
  render() {
    const { showComponent, deviceWidth, deviceHeight } = this.state;
    const {
      noBackgroundOpacity,
      style,
      barStyle,
      closeRootStyle,
      onClose,
      allowTouchOutside,
      closeOnTouchOutside,
      bgStyle = {},
    } = this.props;
    return showComponent ? (
      <Animated.View
        style={[
          SwipeablePanelStyles.background,
          appStyles.maxWidth,
          {
            backgroundColor: noBackgroundOpacity
              ? "rgba(0,0,0,0)"
              : "rgba(0,0,0,0.5)",
            height: allowTouchOutside ? "auto" : deviceHeight,
            width: deviceWidth,
          },
          bgStyle,
        ]}
      >
        {closeOnTouchOutside ? (
          <TouchableWithoutFeedback onPress={() => onClose()}>
            <View
              style={[
                SwipeablePanelStyles.background,
                appStyles.maxWidth,
                {
                  width: deviceWidth,
                  backgroundColor: "rgba(0,0,0,0)",
                  height: allowTouchOutside ? "auto" : deviceHeight,
                },
              ]}
            />
          </TouchableWithoutFeedback>
        ) : null}
        <Animated.View
          style={[
            SwipeablePanelStyles.panel,
            this.props.panelColor
              ? { backgroundColor: this.props.panelColor }
              : {},
            this.props.paddingHorizontal
              ? { paddingHorizontal: this.props.paddingHorizontal }
              : {},
            {
              width: this.props.fullWidth ? deviceWidth : deviceWidth - 50,
            },
            { transform: this.state.pan.getTranslateTransform() },
            style,
          ]}
          {...this._panResponder.panHandlers}
        >
          {!this.props.noBar ? <Bar barStyle={barStyle} /> : null}
          {this.props.showCloseButton ? (
            <Close style={closeRootStyle} onPress={this.props.onClose} />
          ) : null}
          <ScrollView
            onTouchStart={() => {
              return false;
            }}
            onTouchEnd={() => {
              return false;
            }}
            contentContainerStyle={
              SwipeablePanelStyles.scrollViewContentContainerStyle
            }
          >
            {this.state.canScroll ? (
              <TouchableHighlight>
                <View>{this.props.children}</View>
              </TouchableHighlight>
            ) : (
              this.props.children
            )}
          </ScrollView>
        </Animated.View>
      </Animated.View>
    ) : null;
  }
}

const SwipeablePanelStyles = StyleSheet.create({
  background: {
    position: "absolute",
    zIndex: 30,
    elevation: 10,
    bottom: isAndroid ? 0 : 12,
    left: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  panel: {
    position: "absolute",
    left: 0,
    bottom: 0,
    height: "auto",
    width: FULL_WIDTH,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: -1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 1.0,
    elevation: 2,
    zIndex: 40,
  },
  scrollViewContentContainerStyle: {
    width: "100%",
  },
});
